module.exports = (__parcel__import__("d62h1")).then(() => parcelRequire('2geSQ'));